import React from 'react';
import { Link } from 'react-router-dom';

const QUICK = ['About','R&D','Team','News','Careers','Contact'];
const RESEARCH = ['Multi-Scale Modeling','Materials Informatics','Autonomous Fabrication','Validation & Testing','Scale-Up Engineering'];

export default function Footer() {
  const toHref = l => '/' + (l==='R&D'?'rd':l==='Contact'?'contact':l.toLowerCase());

  return (
    <footer className="relative z-[1] border-t overflow-hidden" style={{ background:'var(--bg-0)', borderColor:'var(--border)', padding:'90px 0 36px' }}>
      {/* Glow top */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-px"
        style={{ background:'linear-gradient(90deg,transparent,rgba(0,255,255,0.35) 30%,rgba(139,92,246,0.35) 70%,transparent)', filter:'blur(0.5px)' }} />

      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-flex items-baseline gap-1 mb-4 no-underline">
              <span className="font-display font-extrabold text-[1.7rem] text-white tracking-[-0.04em]">D2S</span>
              <span className="font-mono text-[0.58rem] tracking-[6px] uppercase" style={{ color:'#00ffff' }}>LAB</span>
            </Link>
            <p className="text-sm font-light leading-relaxed mb-5 max-w-[240px]" style={{ color:'var(--text-2)' }}>
              Autonomous Discovery and Validation of Manufacturing Scale-up for Advanced Materials
            </p>
            <div className="flex gap-3 flex-wrap">
              {['LinkedIn','ResearchGate','GitHub'].map(s => (
                <a key={s} href="#" className="font-mono text-[0.62rem] tracking-[1.5px] uppercase px-3 py-1 rounded-full border transition-all duration-300 hover:border-teal/30"
                  style={{ color:'var(--text-3)', background:'rgba(255,255,255,0.04)', borderColor:'var(--border)' }}
                  onMouseEnter={e=>{e.currentTarget.style.color='#00ffff';e.currentTarget.style.borderColor='rgba(0,255,255,0.28)';e.currentTarget.style.background='rgba(0,255,255,0.06)'}}
                  onMouseLeave={e=>{e.currentTarget.style.color='var(--text-3)';e.currentTarget.style.borderColor='var(--border)';e.currentTarget.style.background='rgba(255,255,255,0.04)'}}>
                  {s}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-bold text-[0.85rem] text-white mb-5 relative inline-block
              after:absolute after:bottom-[-6px] after:left-0 after:w-5 after:h-[1.5px] after:rounded-full"
              style={{ '--tw-content':'', '--after-bg':'#00ffff' }}>
              <span style={{ borderBottom:'none' }}>Navigation</span>
              <span className="absolute bottom-[-6px] left-0 w-5 h-[1.5px] rounded-full" style={{ background:'#00ffff', boxShadow:'0 0 8px rgba(0,255,255,0.5)' }} />
            </h4>
            <ul className="flex flex-col gap-[10px]">
              {QUICK.map(l => (
                <li key={l}>
                  <Link to={toHref(l)}
                    className="text-sm font-light transition-all duration-250 hover:pl-1.5 inline-block"
                    style={{ color:'var(--text-2)', fontFamily:'var(--font-body)' }}
                    onMouseEnter={e=>e.currentTarget.style.color='var(--text-1)'}
                    onMouseLeave={e=>e.currentTarget.style.color='var(--text-2)'}>
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Research Areas */}
          <div>
            <h4 className="font-display font-bold text-[0.85rem] text-white mb-5 relative">
              Research Areas
              <span className="absolute bottom-[-6px] left-0 w-5 h-[1.5px] rounded-full" style={{ background:'#8b5cf6', boxShadow:'0 0 8px rgba(139,92,246,0.5)' }} />
            </h4>
            <ul className="flex flex-col gap-[10px]">
              {RESEARCH.map(l => (
                <li key={l}>
                  <Link to="/rd"
                    className="text-sm font-light transition-all duration-250 hover:pl-1.5 inline-block"
                    style={{ color:'var(--text-2)', fontFamily:'var(--font-body)' }}
                    onMouseEnter={e=>e.currentTarget.style.color='var(--text-1)'}
                    onMouseLeave={e=>e.currentTarget.style.color='var(--text-2)'}>
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-bold text-[0.85rem] text-white mb-5 relative">
              Contact
              <span className="absolute bottom-[-6px] left-0 w-5 h-[1.5px] rounded-full" style={{ background:'#f472b6', boxShadow:'0 0 8px rgba(244,114,182,0.5)' }} />
            </h4>
            <p className="text-sm font-light mb-4" style={{ color:'var(--text-2)' }}>Interested in collaboration?</p>
            <Link to="/contact"
              className="btn btn--primary inline-flex mb-5 !py-[10px] !px-[22px] !text-[0.82rem]">
              Get In Touch
            </Link>
            <div className="flex flex-col gap-2">
              {['📍 Advanced Materials Research Center','✉️ hello@d2slab.org'].map(t => (
                <span key={t} className="text-xs font-light" style={{ color:'var(--text-3)', fontFamily:'var(--font-body)' }}>{t}</span>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-7 border-t flex flex-wrap items-center justify-between gap-4" style={{ borderColor:'var(--border)' }}>
          <p className="font-mono text-[0.68rem] tracking-wider uppercase" style={{ color:'var(--text-3)' }}>
            © {new Date().getFullYear()} D2S Lab. All rights reserved.
          </p>
          <div className="flex gap-6">
            {['Privacy Policy','Terms','Accessibility'].map(l => (
              <a key={l} href="#" className="font-mono text-[0.68rem] tracking-wider uppercase transition-colors duration-250"
                style={{ color:'var(--text-3)' }}
                onMouseEnter={e=>e.currentTarget.style.color='#00ffff'}
                onMouseLeave={e=>e.currentTarget.style.color='var(--text-3)'}>
                {l}
              </a>
            ))}
          </div>
          <span className="font-mono text-[0.65rem]" style={{ color:'rgba(0,255,255,0.28)' }}>v2.0 · Built with precision</span>
        </div>
      </div>
    </footer>
  );
}
